interface NavigationItemUpdate {
  isHiddenInNavigation: boolean;
  navTitle?: string;
}

/*
 * The admin pages list (<ul id="sortableNavigation"> in main's admin_view_pagesList.html) is
 * legacy Smarty markup rendered once per page load, outside this React root, and never
 * re-rendered while the editor is used. Its links carry "pageLink--hidden -hidden" when the page
 * is unpublished (page_hidden) or excluded from navigation (page_exclude), so after a publish
 * toggle or save we patch that element directly to keep the list in sync.
 */
export const updateNavigationItem = (
  pageId: string,
  { isHiddenInNavigation, navTitle }: NavigationItemUpdate
): void => {
  const link = document.querySelector(`#pageorder_${pageId} a.pageLink`);

  if (!link) {
    return;
  }

  link.classList.toggle('pageLink--hidden', isHiddenInNavigation);
  link.classList.toggle('-hidden', isHiddenInNavigation);

  if (navTitle !== undefined) {
    link.textContent = navTitle;
  }
};
